import { render, staticRenderFns } from "./ivestorAppStoreLinks.vue?vue&type=template&id=50f77978"
import script from "./ivestorAppStoreLinks.vue?vue&type=script&lang=js"
export * from "./ivestorAppStoreLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports